import { render, staticRenderFns } from "./tag-search-modal.vue?vue&type=template&id=5a05fe2e&scoped=true&"
import script from "./tag-search-modal.vue?vue&type=script&lang=js&"
export * from "./tag-search-modal.vue?vue&type=script&lang=js&"
import style0 from "./tag-search-modal.vue?vue&type=style&index=0&id=5a05fe2e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a05fe2e",
  null
  
)

component.options.__file = "tag-search-modal.vue"
export default component.exports